import { IPurchasePageRequest } from '../../../../model/scp/purchase/request/purchase-paged-request';
import { ITableResponse } from '../../../../model/scp/purchase/response/tables-response';

export type PurchaseSearchState = {
  modality: ITableResponse[];
  situation: ITableResponse[];
  disputeMode: ITableResponse[];
  parameters: IPurchasePageRequest;
  searchTrigger: number;
};

export enum ACTION_TYPES {
  setModality = 'setModality',
  setSituation = 'setSituation',
  setDisputeMode = 'setDisputeMode',
  setParameters = 'setParameters',
  updateParameter = 'updateParameter',
  triggerSearch = 'triggerSearch',
}

export const PurchaseSearchReducer = (state: PurchaseSearchState, action: any): PurchaseSearchState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setModality:
      return {
        ...state,
        modality: payload,
      };
    case ACTION_TYPES.setSituation:
      return {
        ...state,
        situation: payload,
      };
    case ACTION_TYPES.setDisputeMode:
      return {
        ...state,
        disputeMode: payload,
      };
    case ACTION_TYPES.setParameters:
      return {
        ...state,
        parameters: payload,
      };
    case ACTION_TYPES.updateParameter:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          ...payload,
        },
      };
    case ACTION_TYPES.triggerSearch:
      return {
        ...state,
        searchTrigger: state.searchTrigger + 1,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
